var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.fullscreen ? 'ss_loading-fullScreen' : 'ss_loading',style:({
    zIndex: 20,
    background: _vm.background,
    color: _vm.color
  })},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ss_loading__box"},[_c('div',[_vm._v("S")]),_c('div',[_vm._v("H")]),_c('div',[_vm._v("O")]),_c('div',[_vm._v("P")]),_c('div',[_vm._v("S")]),_c('div',[_vm._v("H")]),_c('div',[_vm._v("O")]),_c('div',[_vm._v("P")]),_c('div',[_vm._v("S")])])}]

export { render, staticRenderFns }